const formValidator = (payload) => {
  let isValid = true;
  const obj = {
    type: 'error',
    message: '',
  };
  if (!payload.title) {
    obj.message = 'certification name is required!';
    isValid = false;
  }
  if (!payload.institution_name) {
    obj.message = 'certification authority is required!';
    isValid = false;
  }
  if (!payload.date_from) {
    obj.message = 'certification date is required!';
    isValid = false;
  }
  if (isValid) {
    return 'valid';
  }
  return obj;
};

export default formValidator;
